import { Chip, useThemeColors, ColorsV2 } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

export const ZtpNotEnabledChip = () => {
  const { t } = useTranslation('storefront');
  const [textColor, backgroundColor] = useThemeColors([
    ColorsV2.WARNING_DARKEST,
    ColorsV2.WARNING_LIGHTEST,
  ]);

  return (
    <Chip
      id="ztp-not-enabled-chip"
      icon="shield-x"
      textColor={textColor}
      backgroundColor={backgroundColor}
      variant="small">
      {t('ztp.chips.notEnabled')}
    </Chip>
  );
};
